import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import api from "../api";
import { cookies } from "../services/cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(!!cookies.get("access_token")); // token байвал loading true
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(cookies.get("access_token"));

  const removeAuth = () => {
    cookies.remove("access_token");
    setIsAuthenticated(false);
    setToken("");
    setUser(null);
  };

  const setAuth = useCallback((accessToken, userData = null) => {
    cookies.set("access_token", accessToken);
    setToken(accessToken); // ← useEffect дахин ажиллана
    setIsAuthenticated(true);
    if (userData) setUser(userData);
  }, []);

  const fetchMe = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.me();
      if (res?.status === 200) {
        setIsAuthenticated(true);
        setUser(res.data);
      } else {
        removeAuth();
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (token && !user) {
      fetchMe();
    } else {
      setLoading(false);
    }
  }, [token]);

  if (loading) return null;

  return (
    <AuthContext.Provider
      value={{ removeAuth, isAuthenticated, user, setUser, setAuth }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within an AuthProvider");
  return context;
};
